import { IconsProps, ThemeUnion } from '@almbrand/systemicons/dist/cjs/types/icon';
import { SearchFieldOption } from 'components/2-molecules/SearchFieldComponent/SearchFieldComponent';
import { Page } from 'context/PageContext';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { InsuranceCompanySearch } from './InsuranceCompanySearch';
import { SpdSearch } from './SpdSearch';
import { ZipcodeAddressSearch } from './ZipcodeAddressSearch';

export type SearchObjectResponse = Record<string, string | number | boolean | null | undefined>;
export type SearchResult = SearchFieldOption[] | SearchObjectResponse;

export interface SearchComponent {
	init: () => Promise<SearchResult>;
	handleChange?: (option: SearchFieldOption) => Promise<SearchFieldOption>;
	handleSecondaryChange?: (option: SearchFieldOption, register: UseFormRegister<FieldValues>) => Promise<void>;
	handleInputChange?: (value: string) => Promise<SearchFieldOption[]>;
	apiSearch: boolean;
	minInputLength?: number;
	searchIcon: IconsProps<ThemeUnion>['icon'];
	searchConfiguration: SearchConfiguration;
	secondarySearchConfiguration?: SearchConfiguration;
}

export enum HttpMethod {
	GET = 'GET',
	POST = 'POST',
	DELETE = 'DELETE',
	PATCH = 'PATCH',
}
export enum FrontendDatasourceEvent {
	INSURANCE_COMPANIES = 'InsuranceCompaniesEvent',
	ZIPCODE = 'ZipcodeEvent',
	ADDRESS = 'AddressEvent',
	ZIPCODE_BY_ADDRESS = 'ZipcodeByAddressEvent',
	SPD_ZIPCODE_ADDRESS = 'SpdZipcodeAddressEvent',
	CUSTOM_EVENT = 'CustomEvent',
}
interface InputField {
	content: {
		uniqueIdentifier?: {
			uid?: string;
			contentType?: string;
			contentId?: number;
			contentName?: string;
		};
		param?: string;
		mandatory?: boolean;
		contentType?: string;
		contentId?: number;
		contentName?: string;
	};
}
interface OutputField {
	content: {
		uniqueIdentifier?: {
			uid?: string;
			contentType?: string;
			contentId?: number;
			contentName?: string;
		};
		fieldName: string;
		fieldValueType: 'string' | 'Boolean' | 'Integer';
		contentType: 'SearchFieldConfigurationOutputFieldBlock';
		contentId: number;
		param?: string;
	};
}

export interface SearchConfiguration {
	frontendDatasourceEvent?: string;
	spdSearchConfigurationName?: string;
	httpMethod?: HttpMethod;
	inputFields?: { items: InputField[] };
	outputFields?: { items: OutputField[] };
	responseType?: 'obj' | 'lov';
	url?: string;
}

export const getSearchComponent = (
	searchConfiguration: SearchConfiguration,
	pageContext: Partial<Page>,
	secondarySearchConfiguration?: SearchConfiguration
): SearchComponent => {
	if (!searchConfiguration?.frontendDatasourceEvent) {
		// TODO: Add this when preloading is in place.
		//return sessionStorage.getItem('spdSearchPayload') ? new SpdSearch(searchConfiguration, pageContext) : null;
		return new SpdSearch(searchConfiguration, pageContext);
	}

	switch (searchConfiguration.frontendDatasourceEvent) {
		case FrontendDatasourceEvent.ADDRESS:
		case FrontendDatasourceEvent.ZIPCODE:
		case FrontendDatasourceEvent.ZIPCODE_BY_ADDRESS:
			return new ZipcodeAddressSearch(searchConfiguration, pageContext, secondarySearchConfiguration);
		case FrontendDatasourceEvent.INSURANCE_COMPANIES:
			return new InsuranceCompanySearch(searchConfiguration);
		case FrontendDatasourceEvent.CUSTOM_EVENT:
			break;
		default:
			break;
	}
};
